import { TNotificationApi, TNotificationFilterOption } from '@/types/Notification.types';
import { usePaginatedSearch } from '../usePaginatedSearch';
import { TSortingParams } from '@/types';
import { getNotificationsAllAdmin } from '@/services/api/requests/notifications';
import queryKeys from '@/constants/queryKeys';

const useAllNotifications = ({
  filterOption,
  filterText,
  sortingColumn,
  sortingDirection,
}: {
  filterOption?: TNotificationFilterOption;
  filterText: string;
} & TSortingParams) => {
  return usePaginatedSearch<TNotificationApi[], TNotificationFilterOption, string>({
    query: (page, searchFilterType, searchFilterText, sortingColumn, sortingDirection) =>
      getNotificationsAllAdmin(page, searchFilterType, searchFilterText, sortingColumn, sortingDirection),
    queryKey: [queryKeys.notifications.allNotifications],
    searchFilterType: filterOption ?? 'Text',
    searchFilterText: filterText,
    sortingColumn: sortingColumn ?? 'Created At',
    sortingDirection: sortingDirection,
  });
};

export default useAllNotifications;
